"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PSCDateOfBirth$ = exports.PSCDateOfBirth$outboundSchema = exports.PSCDateOfBirth$inboundSchema = void 0;
exports.pscDateOfBirthToJSON = pscDateOfBirthToJSON;
exports.pscDateOfBirthFromJSON = pscDateOfBirthFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.PSCDateOfBirth$inboundSchema = z.object({
    month: z.nullable(z.number().int()),
    year: z.nullable(z.number().int()),
});
/** @internal */
exports.PSCDateOfBirth$outboundSchema = z.object({
    month: z.nullable(z.number().int()),
    year: z.nullable(z.number().int()),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PSCDateOfBirth$;
(function (PSCDateOfBirth$) {
    /** @deprecated use `PSCDateOfBirth$inboundSchema` instead. */
    PSCDateOfBirth$.inboundSchema = exports.PSCDateOfBirth$inboundSchema;
    /** @deprecated use `PSCDateOfBirth$outboundSchema` instead. */
    PSCDateOfBirth$.outboundSchema = exports.PSCDateOfBirth$outboundSchema;
})(PSCDateOfBirth$ || (exports.PSCDateOfBirth$ = PSCDateOfBirth$ = {}));
function pscDateOfBirthToJSON(pscDateOfBirth) {
    return JSON.stringify(exports.PSCDateOfBirth$outboundSchema.parse(pscDateOfBirth));
}
function pscDateOfBirthFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PSCDateOfBirth$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PSCDateOfBirth' from JSON`);
}
//# sourceMappingURL=pscdateofbirth.js.map